<app-field-details-dialog
  [view]="fieldView()"
  (close)="onInnerClose()"
/>
